/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  const colors = require('tailwindcss/colors')
  
  module.exports = {
    // ...
    theme: {
      extend: {
        colors: {
          sky: colors.sky,
          teal: colors.teal,
          rose: colors.rose,
        },
      },
    },
  }
  ```
*/

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { TWclassNames } from "./Div";
import { MobileBottomSheet } from "./mobile-bottom-sheet";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function PMLinkCard({ cols = 1, hideMobileSelect = false, ...props }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sheetOpen, setSheetOpen] = useState(false);

  const actions = props?.actions.filter((action) => action.active);

  const handleAction = (action) => {
    setSheetOpen(false);
    if (action.action) {
      action.action();
    } else if (action.path) {
      navigate(action.path);
    }
  };

  const isShowing = (action) => {
    if (action.show === undefined) {
      return true;
    } else if (action.show === true) {
      return true;
    } else return false;
  };

  const sheetItems =
    actions?.map((action, index) => ({
      key: `${action.label}-${index}`,
      label: action.mobileLabel || action.label,
      description: action.description,
      icon: action.icon,
      iconForeground: action.iconForeground,
      iconBackground: action.iconBackground,
      onClick: () => handleAction(action),
    })) || [];

  return (
    <>
      {!hideMobileSelect && sheetItems.length > 0 ? (
        <>
          <div className="sm:hidden w-full">
            <button
              type="button"
              onClick={() => setSheetOpen(true)}
              className="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-left text-sm text-gray-700 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              aria-haspopup="menu"
              aria-expanded={sheetOpen}
            >
              <span>{t("pmLinkCard.actionsTitle")}</span>
              <ChevronDownIcon className="h-4 w-4 text-gray-400" aria-hidden />
            </button>
          </div>
          <MobileBottomSheet
            open={sheetOpen}
            onClose={() => setSheetOpen(false)}
            title={t("pmLinkCard.actionsTitle")}
            ariaLabel={t("pmLinkCard.actionsTitle")}
            items={sheetItems}
            hideFromLg={false}
          />
        </>
      ) : null}
      <div
        className={`hidden sm:grid grid-cols-${cols} gap-4 sm:grid-cols-${cols}`}
      >
        {!actions
          ? null
          : actions.map((action) => {
              if (isShowing(action)) {
                return (
                  <>
                    <div
                      key={action.label}
                      onClick={() => handleAction(action)}
                      className={TWclassNames(
                        action.completed ? "bg-green-200" : "bg-white",
                        "relative flex items-center grid-span-1 space-x-3 rounded-lg border border-gray-300 px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
                      )}
                    >
                      <div className="flex-shrink-0">
                        <span
                          className={classNames(
                            action.iconBackground,
                            action.iconForeground,
                            "rounded-lg inline-flex p-3 ring-4 ring-white"
                          )}
                        >
                          <action.icon className="h-6 w-6" aria-hidden="true" />
                        </span>
                      </div>
                      <div className="min-w-0 flex-1">
                        <a className="focus:outline-none cursor-pointer">
                          <span
                            className="absolute inset-0"
                            aria-hidden="true"
                          />
                          <p className="text-sm font-medium text-gray-900">
                            {action.label}
                          </p>
                          <p className="truncate text-sm text-gray-500">
                            {action.description}
                          </p>
                        </a>
                      </div>
                    </div>
                  </>
                );
              }
            })}
      </div>
    </>
  );
}
